export enum InvoicePaymentType {
    TOTAL_PAYMENT = 'Pago Total',
    PARTIAL_PAYMENT = 'Pago Parcial'
}